/** Каталог якорей модуля «Аудиты» */
export const AUDITS_ANCHORS = {
  toolbar: {
    createAudit: 'audits.toolbar.createAudit',
    createGroup: 'audits.toolbar.createGroup',
    navFirst: 'audits.toolbar.nav.register',
    navLast: 'audits.toolbar.nav.archive',
  },
  register: {
    search: 'audits.register.search',
    overdue: 'audits.register.overdue',
    requiresAction: 'audits.register.requiresAction',
    resetFilters: 'audits.register.resetFilters',

    /** Префикс якоря заголовка колонки с фильтром, дальше — ключ колонки из `headers` */
    filterPrefix: 'audits.register.filter.',
    filterFirst: 'audits.register.filter.id',
    filterLast: 'audits.register.filter.audit_type',
    /** Самый высокий заголовок (в две строки) — по нему подсветка фильтров берёт высоту */
    filterTallest: 'audits.register.filter.parents',
    demoRow: 'audits.register.demoRow',
  },
  card: {
    start: 'audits.card.start',
    downloads: 'audits.card.downloads',
    checklist: 'audits.card.checklist',
    report: 'audits.card.report',
    nonconformities: 'audits.card.nonconformities',
    edit: 'audits.card.edit',
    departments: 'audits.card.departments',
    assignments: 'audits.card.assignments',
  },
  process: {
    criteria: 'audits.process.criteria',
    questions: 'audits.process.questions',
    comment: 'audits.process.comment',
    decision: 'audits.process.decision',
  },
  table: {
    search: 'audits.table.search',
    resetFilters: 'audits.table.resetFilters',
    content: 'audits.table.content',
  },
  chart: {
    views: 'audits.chart.views',
    calendar: 'audits.chart.calendar',
    create: 'audits.chart.create',
    /** Мини-календарь сайдбара: клик по дате показывает месяц и задаёт число начала проверки */
    datePicker: 'audits.chart.datePicker',
    types: 'audits.chart.types',
  },
} as const

export const AUDITS_CONTEXTS = {
  toolbar: 'audits.toolbar',
  register: 'audits.register',
  card: 'audits.card',
  process: 'audits.process',
  nonconformities: 'audits.nonconformities',
  groups: 'audits.groups',
  archive: 'audits.archive',
  chart: 'audits.chart',
} as const
